module.exports = __webpack_public_path__ + "img/trainingInstitutionData.c542bf05.svg";